
import { useDebounce } from '@utils/useDebounce';
import { FillMatrixValueInput, useFillMatrixValueMutation } from 'gql/index';
import { useCallback } from 'react';
import { useFormFillerHelpers } from '../../useFormFillerHelpers';
import { autoSaveTimeout } from '../useFormFieldFillerForm';

export const useMatrixFiller = () => {

  const { onFormFillSaving, onFormFillSuccess: onSuccess, onFormFillError: onError } = useFormFillerHelpers();

  const { mutate: fillMatrixValue, mutateAsync: fillMatrixValueAsync } = useFillMatrixValueMutation({ onError, onSuccess });

  const onValueUpdated = useDebounce((matrixValueId: number, input: Omit<FillMatrixValueInput, 'matrixValueId'>) => {
    onFormFillSaving();
    fillMatrixValue({ input: { ...input, matrixValueId } });
  }, autoSaveTimeout);

  const addNewValue = useCallback(async (input: Omit<FillMatrixValueInput, 'matrixValueId'>) => {
    onFormFillSaving();
    const result = await fillMatrixValueAsync({ input });
    return result.fillMatrixValue.matrixValue?.id;
  }, [fillMatrixValueAsync, onFormFillSaving]);

  return { onValueUpdated, addNewValue };
};